import React, { Component } from 'react';
import { connect } from "react-redux";

import {baseNewImagesPath} from "../assets";
import MobileMenu from "../ui/mobileMenu";
import ShoppingCartButton from "../ui/shoppingCartButton";
import UserLoginButton from './../ui/userLoginButton';

class ProjectScopeMobileHeader extends Component {

  render() {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const hardCodedLogo = `${baseNewImagesPath}images/Logos/QuoteCountertops-Logo.svg`;
    const logoStyles = this.props.fabricatorData.logoUrl ? {} : {
      maxWidth: "500px",
      width: "100%"
    };
    const initialFlowIsRunning = document.kvConfig.initialFlowEnabled && this.props.initialFlowStep !== 3;
    return (
      <div className="newscope-header">
        <div className="newscope-header__menu">
          <MobileMenu/>
        </div>
        {this.props.fabricatorData.received ? (
          <div className="newscope-header__logo">
            <img src={this.props.fabricatorData.logoUrl || hardCodedLogo} style={logoStyles} alt="Logo"/>
          </div>
        ) : null}
        {fabricatorSettings.showPricing && !initialFlowIsRunning ? (
          <div className="newscope-header__cart">
            <ShoppingCartButton/>
          </div>
        ): null}
        {(fabricatorSettings.leadCaptureOnQuote && !initialFlowIsRunning &&
          !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
          ? <UserLoginButton className="newscope-header__login"/>
          : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    initialFlowStep: store.initialFlowState.initialFlowStep
  };
};

export default connect(mapStateToProps)(ProjectScopeMobileHeader);
